import render from './render'

export default {
  name: 'Footer',

  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },

    label: String,
    description: String,

    dialog: Boolean,
    disabled: Boolean,
    showDescription: Boolean
  },

  data() {
    return {
      showDialog: false
    }
  },

  render
}
